<template>
  <div class="c-table" :class="{ 'c-table--loading': loading }">
    <table class="c-table__table o-table o-table--fixed">
      <thead>
        <tr class="c-table__row c-table__row--head">
          <th
            v-for="(value, name) in columns"
            :key="name.id"
            @click="sortBy(name)"
            class="c-table__column-header"
            :class="sortClass(name)"
            :colspan="value.width"
          >
            <span>{{ value.name }}</span>
            <svg
              class="c-table__direction-icon c-table__direction-icon--ascending o-svg-icon"
              viewBox="0 0 64 64"
              type="image/svg+xml"
            >
              <use
                xlink:href="spritemap.svg#sprite-hjs-sorting-ascending"
                x="0"
                y="0"
              ></use>
            </svg>
            <svg
              class="c-table__direction-icon c-table__direction-icon--descending o-svg-icon"
              viewBox="0 0 64 64"
              type="image/svg+xml"
            >
              <use
                xlink:href="spritemap.svg#sprite-hjs-sorting-descending"
                x="0"
                y="0"
              ></use>
            </svg>
          </th>
        </tr>
      </thead>
      <tbody class="c-table__tbody" v-for="item in items" :key="item.id">
        <tr
          :tabindex="activeItem === item.id ? '' : 0"
          class="c-table__row"
          :class="{ 'c-table__row--active': activeItem === item.id }"
          @keyup.enter="setActiveItem(item.id)"
          @click.stop="setActiveItem(item.id)"
        >
          <td
            class="c-table__item c-table__item--address"
            :colspan="columns.address.width"
          >
            <div :title="item.address" class="c-table__item-text">
              {{ item.address }}
            </div>
          </td>
          <td class="c-table__item" :colspan="columns.organisation.width">
            <div :title="item.organisation" class="c-table__item-text">
              {{ item.organisation }}
            </div>
          </td>
          <td class="c-table__item" :colspan="columns.fadder.width">
            <div :title="item.fadder" class="c-table__item-text">
              {{ item.fadder }}
            </div>
          </td>
          <td class="c-table__item" :colspan="columns.phone.width">
            <div :title="item.phone" class="c-table__item-text">
              {{ item.phone }}
            </div>
          </td>
          <td
            class="c-table__item c-table__item--modyfied"
            :colspan="columns.lastUpdated.width"
          >
            <div
              :title="item.lastUpdated | formatDate('DD. MMM. YYYY')"
              class="c-table__item-text"
            >
              <span>{{ item.lastUpdated | formatDate("DD. MMM. YYYY") }}</span>
              <span>{{
                item.lastUpdatedProfile
                  ? item.lastUpdatedProfile
                  : item.lastUpdatedSystemUser
              }}</span>
            </div>
          </td>
          <td class="c-table__item" :colspan="columns.assignee.width">
            <div :title="item.assignee" class="c-table__item-text">
              {{ item.assignee || customTranslations.unassigned }}
            </div>
          </td>
          <td class="c-table__item" :colspan="columns.status.width">
            <div
              :title="statusTranslations.code[item.statusText]"
              class="c-table__item-text"
            >
              <span
                class="o-status--text"
                :class="item.statusValue | statusToColor"
              >
                {{ statusTranslations.code[item.statusText] }}
              </span>
            </div>
          </td>
        </tr>
        <transition name="o-transition__fade">
          <tr v-if="activeItem === item.id">
            <td colspan="36">
              <tableModal :itemId="item.id"></tableModal>
            </td>
          </tr>
        </transition>
      </tbody>
    </table>
    <tablePageSize
      :handleClick="setPageSize"
      :options="pageSizeOptions"
      :activeOption="parameters.pageSize"
    />
    <v-paginate
      v-model="parameters.pageNo"
      :page-count="totalPages"
      :click-handler="navigateToPage"
      :first-button-text="customTranslations.firstPage"
      :prev-text="customTranslations.previousPage"
      :next-text="customTranslations.nextPage"
      :last-button-text="customTranslations.lastPage"
      :container-class="'c-paging'"
      :page-link-class="'c-paging__item'"
      :disabled-class="'c-paging__item--disabled'"
      :break-view-link-class="'c-paging__item--hidden'"
      :active-class="'c-paging__item--active'"
      :prev-link-class="'c-paging__item c-paging__item--prev'"
      :next-link-class="'c-paging__item c-paging__item--next'"
      :margin-pages="0"
      :first-last-button="true"
      :page-range="5"
      :no-li-surround="true"
    >
    </v-paginate>
  </div>
</template>

<script>
import tableModal from "@/components/tableModal.vue";
import tablePageSize from "@/components/tablePageSize.vue";
import { mapState } from "vuex";
export default {
  name: "c-table",
  data() {
    return {
      activeItem: 0,
      activePage: 1,
      getAllAction: "aeds/getAll",
      columns: {
        address: { name: "Adresse", width: 6 },
        organisation: { name: "Organisation", width: 5 },
        fadder: { name: "Fadder", width: 5 },
        phone: { name: "Telefon", width: 3 },
        lastUpdated: { name: "Sidste ændring", width: 8 },
        assignee: { name: "Ejer", width: 5 },
        status: { name: "Status", width: 4 }
      },
      transitionDuration: 0
    };
  },
  components: {
    tableModal,
    tablePageSize
  },
  computed: {
    ...mapState("aeds", ["parameters"]),
    ...mapState("translations", {
      statusTranslations: "status",
      customTranslations: "custom"
    }),
    items() {
      return this.$store.state.aeds.items;
    },
    totalPages() {
      return this.$store.state.aeds.totalPages;
    },
    loading() {
      return this.$store.state.aeds.loading;
    },
    columnsCount() {
      return this.columns && Object.keys(this.columns).length;
    },
    pageSizeOptions() {
      return ["20", "50", "100"];
    },
    pageSize() {
      return this.$store.state.aeds.parameters.pageSize;
    }
  },
  methods: {
    sortBy(column) {
      this.activeItem = 0;

      if (column === this.parameters.field) {
        this.parameters.direction =
          this.parameters.direction === "descending"
            ? "ascending"
            : "descending";
      } else {
        this.parameters.direction = "ascending";
      }
      this.parameters.field = column;
      this.$store.dispatch(this.getAllAction, this.payload);
    },
    sortClass(column) {
      let columnClass = "";
      if (this.parameters.field === column) {
        columnClass = "c-table__column-header--active";
        if (this.parameters.direction === "descending") {
          columnClass = columnClass + " c-table__column-header--descending";
        }
      }
      return columnClass;
    },
    navigateToPage() {
      this.activeItem = 0;
      this.$store.dispatch(this.getAllAction, this.payload);
    },
    setActiveItem(itemId) {
      if (this.activeItem !== itemId) {
        this.activeItem = itemId;
      } else {
        this.activeItem = 0;
      }
    },
    setPageSize(value) {
      this.parameters.pageSize = value;
      this.parameters.pageNo = 1;

      this.$store.dispatch(this.getAllAction, this.payload);
    }
  },
  created() {
    this.payload = { api: this.$api, parameters: this.parameters };
    this.$store.dispatch(this.getAllAction, this.payload);
  }
};
</script>
<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-table {
  $root: &;
  &--loading {
    opacity: 0.5;
    pointer-events: none;
  }

  &__table {
    width: 100%;
    text-align: left;
  }
  &__tbody {
    &:before {
      content: "";
      display: block;
      height: toRem(2px);
    }
  }

  &__column-header {
    text-decoration: underline;
    font-weight: 700;
    padding: toRem(8px 15px);
    &:after {
      content: "";
    }

    span {
      @include setStyles("13", $s-typography-sizes);
    }

    &:last-child {
      text-align: right;
    }

    &:hover:not(.c-table__column-header--no-hover) {
      color: $s-cp-sup-blue;
      cursor: pointer;
      #{$root}__direction-icon {
        fill: $s-cp-sup-blue;
        &--ascending {
          display: inline-block;
        }
      }
    }

    &--active {
      position: relative;

      &:hover {
        #{$root}__direction-icon--ascending {
          display: none;
        }
        #{$root}__direction-icon--descending {
          display: inline-block;
        }
      }
      #{$root}__direction-icon--ascending {
        display: inline-block;
      }
      #{$root}__direction-icon--descending {
        display: none;
      }
    }

    &--descending {
      #{$root}__direction-icon--ascending {
        display: none;
      }
      #{$root}__direction-icon--descending {
        display: inline-block;
      }
      &:hover {
        #{$root}__direction-icon--ascending {
          display: inline-block;
        }
        #{$root}__direction-icon--descending {
          display: none;
        }
      }
    }
  }

  &__direction-icon {
    width: toRem(30px);
    height: toRem(30px);
    margin-left: toRem(5px);
    display: inline-block;
    vertical-align: middle;
    fill: black;
    display: none;
  }

  &__row {
    @include setStyles("14", $s-typography-sizes);
    background-color: $s-cp-neutral-white;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    &:not(.c-table__row--head):hover {
      cursor: pointer;
      background-color: $s-cp-neutral-800;

      #{$root}__item--address {
        text-decoration: underline;
      }
    }
    &--active,
    &--active:hover {
      background-color: $s-cp-sup-light;
      cursor: default;
    }
    &--head {
      box-shadow: none;
      border: 1px solid $s-cp-neutral-600;
    }
  }

  &__item {
    padding: toRem(10px 15px 15px);

    &:last-child {
      text-align: right;
    }
    &--address {
      color: $s-cp-sup-blue;
      font-weight: 700;
    }
    &--modyfied {
      span:last-child {
        color: $s-cp-neutral-400;
        margin: toRem(0 0 0 5px);
      }
    }
  }

  &__item-text {
    @include setStyles("14", $s-typography-sizes);
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.c-paging {
  margin: toRem(30px 0 20px);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  &__item {
    @include setStyles("15", $s-typography-sizes);
    color: $s-cp-sup-blue;
    width: toRem(40px);
    height: toRem(40px);
    line-height: toRem(40px);
    text-align: center;
    border: 1px solid $s-cp-neutral-700;
    border-radius: toRem(2px);
    background-color: $s-cp-neutral-white;
    margin: toRem(0 3px);
    font-weight: 700;

    &:first-child,
    &:last-child,
    &--prev,
    &--next {
      background: transparent;
      border: none;
      color: $s-cp-sup-blue;
      position: relative;
      padding: toRem(0 15px);
      width: auto;
      border-radius: 0;
      margin: 0;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
    &:first-child,
    &--prev {
      &:before {
        content: "";
        margin: 0 10px 1px 0px;
        display: inline-block;
        border-right: 1px solid $s-cp-sup-blue;
        border-bottom: 1px solid $s-cp-sup-blue;
        width: 8px;
        height: 8px;
        transform: rotate(-225deg);
      }
    }

    &:last-child,
    &--next {
      &:after {
        content: "";
        margin: 0 0 1px 10px;
        display: inline-block;
        border-right: 1px solid $s-cp-sup-blue;
        border-bottom: 1px solid $s-cp-sup-blue;
        width: 8px;
        height: 8px;
        transform: rotate(-45deg);
      }
    }

    &:first-child {
      border-right: toRem(1px) solid $s-cp-neutral-600;
    }
    &:last-child {
      border-left: toRem(1px) solid $s-cp-neutral-600;
    }

    &--hidden {
      display: none;
    }

    &--disabled:first-child,
    &--disabled:last-child,
    &--disabled {
      color: $s-cp-neutral-400;
      cursor: default;

      &:hover {
        text-decoration: none !important;
      }

      &:before,
      &:after {
        border-color: $s-cp-neutral-400;
      }
    }

    &--active {
      color: $s-cp-neutral-black;
      background-color: $s-cp-neutral-700;
    }
  }
}
</style>
